export default __webpack_public_path__ + "static/media/loader-spinner.1b76c08b.gif";